// This code has been partially generated by an AI.
import { Routes } from '@angular/router';
import { adminSettingsGuard } from '@app/core/guards/admin-settings.guard';
import { employeeRegisteredGuard } from '@app/core/guards/employee-registered.guard';
import { WrapperComponent } from '@app/pages/wrapper/wrapper.component';

const homeRoutes = () => import('./pages/home/home.routes').then(m => m.HOME_ROUTES);

const adminSettingsRoutes = () => import('./pages/admin-settings/admin-settings.routes').then(m => m.ADMIN_SETTINGS_ROUTES);
const userBlockedRoutes = () => import('./pages/user-blocked/user-blocked.routes').then(m => m.USER_BLOCKED_ROUTES);
const certificateRoutes = () => import('./pages/certificate/certificate.routes').then(m => m.CERTIFICATE_ROUTES);
const profileRoutes = () => import('./pages/profile/profile.routes').then(m => m.PROFILE_ROUTES);

export const routes: Routes = [
  {
    path: 'blocked',
    runGuardsAndResolvers: 'always',
    loadChildren: userBlockedRoutes,
  },
  {
    path: '',
    canActivate: [employeeRegisteredGuard],
    children: [
      {
        path: 'home',
        component: WrapperComponent,
        children: [{ path: '', loadChildren: homeRoutes }],
      },
      {
        path: 'certificate',
        component: WrapperComponent,
        children: [{ path: '', loadChildren: certificateRoutes }],
      },
      {
        path: 'profile',
        component: WrapperComponent,
        children: [{ path: '', loadChildren: profileRoutes }],
      },
      {
        path: 'admin-settings',
        loadChildren: adminSettingsRoutes,
        canActivate: [adminSettingsGuard],
      },
      {
        path: 'subordinates',
        component: WrapperComponent,
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/subordinates-list/subordinates-list.component').then(m => m.SubordinatesListComponent),
          },
        ],
      },
      {
        path: '**',
        redirectTo: 'home',
      },
    ],
  },
];
